// src/components/LoggedOut/ProductCard.jsx

import React from "react";
import { Card, Button, Grid } from "antd";
import { HeartOutlined, HeartFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "../../styles/ProductCard.css";
import logoFallback from "../../images/logo1.PNG";

const { Meta } = Card;
const { useBreakpoint } = Grid;

export default function ProductCard({ product, onAddToFavorites, isFavorite }) {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  // Aquí construimos el link para React Router SIN “public”:
  const productUrl = `/products/${encodeURIComponent(product.FCNombre)}/${product.FIProducto}`;

  const imageUrl = product.image || logoFallback;
  const precioFormateado = `$${product.FNPrecioVenta.toLocaleString()}`;
  const marcasTexto = Array.isArray(product.FCMarca)
    ? product.FCMarca.join(", ")
    : "";

  if (isMobile) {
    return (
      <div className="product-card-wrapper">
        <Card
          hoverable
          className="product-card-mobile"
          cover={
            <img
              alt={product.FCNombre}
              src={imageUrl}
              className="product-card-image-mobile"
            />
          }
          actions={[
            <Link key="details" to={productUrl}>
              <Button type="primary" className="card-button-mobile-details">
                Detalles
              </Button>
            </Link>,
            <Button
              key="favorite"
              type="text"
              className="card-button-mobile-fav"
              onClick={() => onAddToFavorites(product)}
            >
              {isFavorite ? (
                <HeartFilled style={{ color: "#e0245e", fontSize: "14px", lineHeight: 1 }} />
              ) : (
                <HeartOutlined style={{ fontSize: "14px", lineHeight: 1 }} />
              )}
            </Button>,
          ]}
        >
          <Meta
            title={
              <div className="product-card-text-mobile">
                <span className="product-card-title-mobile">{product.FCNombre}</span>
                <span className="product-card-price-mobile">{precioFormateado}</span>
              </div>
            }
          />
        </Card>
      </div>
    );
  }

  return (
    <div className="product-card-wrapper">
      <Card
        hoverable
        className="product-card-ant compact-ant"
        cover={
          <img
            alt={product.FCNombre}
            src={imageUrl}
            className="product-card-image-ant"
          />
        }
        actions={[
          <Link key="details" to={productUrl}>
            <Button type="primary" className="card-button-details-compact">
              Ver detalles
            </Button>
          </Link>,
          <Button
            key="favorite"
            type="text"
            className="card-button-favorite-only-icon"
            onClick={() => onAddToFavorites(product)}
          >
            {isFavorite ? (
              <HeartFilled style={{ color: "#e0245e", fontSize: "14px", lineHeight: 1 }} />
            ) : (
              <HeartOutlined style={{ fontSize: "14px", lineHeight: 1 }} />
            )}
          </Button>,
        ]}
      >
        <Meta
          title={
            <div className="product-card-text-compact">
              <span className="product-card-title-compact">{product.FCNombre}</span>
              <span className="product-card-brand-price-compact">
                {marcasTexto} {marcasTexto && "·"} {precioFormateado}
              </span>
            </div>
          }
        />
      </Card>
    </div>
  );
}
